import { render, staticRenderFns } from "./PlantillasWhatsApp.vue?vue&type=template&id=ce4d6c5e&scoped=true"
import script from "./PlantillasWhatsApp.vue?vue&type=script&lang=js"
export * from "./PlantillasWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./PlantillasWhatsApp.vue?vue&type=style&index=0&id=ce4d6c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4d6c5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
